import { EditUserBskComponent } from './edit-userbsk/edit-userbsk.component';
import { AddUserBskComponent } from './add-userbsk/add-userbsk.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListUserBskComponent } from './list-userbsk/list-userbsk.component';

export const routesUserBsk: Routes = [
    { path: 'page-userbsk', component: ListUserBskComponent},
    { path: 'page-userbsk/add', component: AddUserBskComponent},
    { path: 'page-userbsk/:id/edit', component: EditUserBskComponent}
];

export const UserBskRoutes: ModuleWithProviders = RouterModule.forChild(routesUserBsk);
